import { defineComponent as o } from "vue";
import { Shimmer as e } from "@ado/acs-standard-library";
import "@ado/acs-standard-library/style.css";
const i = o({
  name: "NavigationSkeletonMobile",
  components: {
    Shimmer: e
  }
});
export {
  i as default
};
//# sourceMappingURL=index27.js.map
